// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1L2Gs","title":"ClientInsurance_title__2RbEA","itemText":"ClientInsurance_itemText__2p5Zd"};